import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  SimpleChanges,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AppsService } from '../../../apps.service';
import { marked } from 'marked';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AreYouSureDialogComponent } from '../../../../shared/are-you-sure-dialog/are-you-sure-dialog.component';
import { switchMap, take, tap } from 'rxjs';
import { DialogService } from '../../../../../shared/services/dialog.service';
import { jsonResponseApi } from '../../../../../shared//models/json-response.model';
export enum CloseType {
  RISK_ACCEPTED = 'Risk accepted',
  COMPENSATING_CONTROL = 'Compensating control',
}

@Component({
  selector: 'app-finding-detail-dialog',
  templateUrl: './finding-detail-dialog.component.html',
  styleUrls: ['./finding-detail-dialog.component.scss'],
})
export class FindingDetailDialogComponent implements OnInit {
  dataFinding: any;
  chkios: boolean;

  appForm: UntypedFormGroup;
  dataTitle: string;
  dataDescriptionIntro: string;
  dataFindingTargets: any;
  dataDescription: string;
  dataRecommendation: string;
  dataSecureCode: string;
  dataCompliance: any;
  dataNotes: any[];
  defaultSeverity: string;

  package: string;
  technology: string;
  app_security_id: string;

  txtQuestionComment: string = '';
  blSendingPost: boolean = false;
  commentType: string = 'internal';
  issuesFormArray: UntypedFormArray;
  closeIssuesForm: UntypedFormGroup;
  closeAllIssuesForm: UntypedFormGroup;
  closeAllFlag: boolean = false;
  loading = false;

  closeTypeDropdown = [
    { name: 'Risk accepted', value: 'CLOSED_RISK_ACCEPTED' },
    { name: 'Compensating control', value: 'CLOSED_COMPENSATING_CONTROL' },
  ];
  severityDropdown = [
    { name: 'Low', value: 'LOW' },
    { name: 'Medium', value: 'MEDIUM' },
    { name: 'High', value: 'HIGH' },
    { name: 'Critical', value: 'CRITICAL' },
  ];

  constructor(
    private objMatDialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<FindingDetailDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public service: AppsService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.package = data.package;
    this.technology = data.technology;
    this.app_security_id = data.app_security_id;
    this.dataFinding = data.result;
    this.issuesFormArray = this.fb.array([]);
    this.closeIssuesForm = this.fb.group({ issues: this.issuesFormArray });
    this.closeAllIssuesForm = this.fb.group({
      permanently: new UntypedFormControl(),
      reason: new UntypedFormControl(null, [Validators.required]),
      close: new UntypedFormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.defaultSeverity = this.dataFinding.severity;
    this.mapSecurityFindingDetail();
    this.appForm = this.formBuilder.group({
      severity: this.dataFinding.severity,
    });
  }

  mapSecurityFindingDetail(): void {
    this.dataTitle = this.dataFinding.title;
    this.dataDescriptionIntro = this.dataFinding.description_intro;
    this.dataFindingTargets = this.dataFinding.security_finding_targets;
    this.dataDescription = this.dataFinding.Description;
    this.dataRecommendation = this.dataFinding.recommendation;
    this.dataSecureCode = this.dataFinding.secure_code;

    this.dataFindingTargets.map((item) => {
      this.issuesFormArray.push(this.createIssueForm());
      return (item.seeMore = false);
    });

    if (this.dataFinding.compliance_policy_references != null) {
      this.dataCompliance = this.dataFinding.compliance_policy_references[0];
    }
    this.dataNotes = this.dataFinding?.notes?.sort((a, b) =>
      a.date_created > b.date_created ? -1 : 1,
    );
  }

  refreshComments(): void {
    const lNote = {
      author_email: 'Lighthouse',
      date_created: new Date().getTime(),
      text: this.txtQuestionComment,
      is_internal_comment: (this.commentType === 'internal').toString(),
    };

    if (this.dataNotes == undefined || this.dataNotes == null) {
      this.dataNotes = [];
    }

    this.dataNotes.push(lNote);
    this.dataNotes = this.dataNotes.sort((a, b) =>
      a.date_created > b.date_created ? -1 : 1,
    );
    this.txtQuestionComment = '';
  }

  seeMore(item) {
    return {
      overflow: item.seeMore,
    };
  }

  checkMoreInfo(item) {
    item.seeMore = !item.seeMore;
  }
  cssClass(item) {
    return {
      up: item.seeMore,
      down: !item.seeMore,
    };
  }

  markItem(text) {
    return marked(text);
  }

  openEnsureModal(i, item) {
    const ensureDialog = this.dialog.open(AreYouSureDialogComponent, {
      height: '800px',
      width: '760px',
      panelClass: 'ensure-modal',
      data: { text: 'Are you sure you want to close target?' },
    });
    ensureDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.loading = true;
        const body = {
          reason: this.issuesFormArray.controls[i].get('reason').value,
          status: this.issuesFormArray.controls[i].get('close').value,
        };
        this.service
          .closeOneTarget(this.data.appUuid, this.data.findingId, item.id, body)
          .pipe(
            take(1),
            switchMap(() =>
              this.service.getSecurityFindingsDetail(
                this.data.appUuid,
                this.data.findingId,
              ),
            ),
          )
          .subscribe((findingsDetail) => {
            this.dataFindingTargets = findingsDetail.security_finding_targets;
            this.loading = false;
          });
      }
    });
  }

  openCloseAllEnsureModal() {
    const ensureDialog = this.dialog.open(AreYouSureDialogComponent, {
      width: '760px',
      height: '800px',
      panelClass: 'ensure-modal',
      data: {
        text: 'Are you sure you want to close all targets in this issue?',
      },
    });
    ensureDialog.afterClosed().subscribe((result) => {
      if (result) {
        const body = {
          is_permanently_closed:
            this.closeAllIssuesForm.get('permanently').value,
          reason: this.closeAllIssuesForm.get('reason').value,
          status: this.closeAllIssuesForm.get('close').value,
        };
        this.service
          .closeAllTargets(this.data.appUuid, this.data.findingId, body)
          .pipe(take(1))
          .subscribe(() => {
            this.dialog.closeAll();
            this.dialogRef.close(true);
          });
      }
    });
  }
  updateSeverity(): void {
    this.openInsufficientRightsModal(this.appForm.get('severity').value);
  }

  private openInsufficientRightsModal(severity) {
    severity = severity[0].toUpperCase() + severity.slice(1).toLowerCase();
    const objDialog: DialogService = new DialogService(this.objMatDialog);

    objDialog.icon = {
      src: '../../../assets/images/icons/warning-icon.svg',
      class: 'clsIcon80x80',
    };

    objDialog.texts = {
      title: 'Are you sure you want to change the severity to ',
      severity: severity,
      extra: '?',
      main: "Don't worry, you will be able to edit the severity again",
      subtext: '',
    };

    objDialog.buttons = [
      {
        btnText: 'NO',
        btnFunc: (pThisDlg: any) => {
          this.appForm = this.formBuilder.group({
            severity: this.defaultSeverity,
          });
          pThisDlg.close();
        },
      },
      {
        btnText: 'YES',
        btnFunc: (pThisDlg: any) => {
          const body = {
            severity: this.appForm.get('severity').value,
          };
          this.service
            .updateFinding(this.data.appUuid, this.data.findingId, body)
            .pipe(take(1))
            .subscribe({
              next: (res: jsonResponseApi) => {
                this.defaultSeverity = this.appForm.get('severity').value;
                this.dataFinding.severity = this.appForm.get('severity').value;
                console.log(res);
                pThisDlg.close();
              },
              error: (error) => {
                console.log(error);
                pThisDlg.close();
              },
            });
        },
      },
    ];
    objDialog.openDialog();
  }
  createIssueForm(): UntypedFormGroup {
    return new UntypedFormGroup({
      permanently: new UntypedFormControl(),
      reason: new UntypedFormControl(null, [Validators.required]),
      close: new UntypedFormControl(null, [Validators.required]),
    });
  }
}
